import WaitingClock from './WaitingClock';

export default WaitingClock;